import Task from './task';
import Email from './email';
import Whatsapp from './whatsapp';
import auth from './auth';
import board from './board';
import column from './column';
import template from './template';
import user from './user';
import permission from './permission';
import automation from './automation';
import userassignboard from './userassignboard';
import group from './group';
import compose from './compose';
import automations from './automations';
import comment from './comment';
import internalnotes from './internalnotes';
import property from './property'
import customfield from './customfield';
import draft from './draft';
import label from './label';
import support from './support';
export default {
    Task,
    Email,
    Whatsapp,
    board,
    auth,
    column,
    template,
    user,
    permission,
    automation,
    userassignboard,
    group,
    compose,
    automations,
    comment,
    internalnotes,
    customfield,
    property,
    draft,
    label,
    support
};
